import { Box, ListItem, ListItemIcon, useTheme } from '@mui/material';
import {
  totalActivityTextSx,
  totalCaloriesSx,
  totalCaloriesTextSx,
  totalDistanceTextSx,
  totalListItemIconSx,
  totalListItemSx,
  totalListItemTextSx,
} from './Total.style';
import { Text } from '../Text/Text';

export const Total = ({ icon, activity, distance, calories }) => {
  const theme = useTheme();

  return (
    <ListItem disablePadding sx={totalListItemSx(theme)}>
      <ListItemIcon sx={totalListItemIconSx(theme)}>{icon}</ListItemIcon>

      <Box component="div" sx={totalListItemTextSx}>
        <Text variant="body2" text={activity} sx={totalActivityTextSx} />
        <Text
          variant="body2"
          text={`${distance} mi`}
          sx={totalDistanceTextSx(theme)}
        />
      </Box>

      <Box component="div" sx={totalCaloriesSx}>
        <Text
          variant="body2"
          text={`~${calories} kcal`}
          sx={totalCaloriesTextSx}
        />
      </Box>
    </ListItem>
  );
};
